export const colors = {
   headerBorder: '#bed600',
   panelBorder: 'rgb(0, 102, 153)',
   boxBackground: '#f2f2f2',
   boxOutline: '#ccc',
   success: '#4d841d',
   error: 'red',
   dragger: '#f4f7f9',
   lightGrey: '#f7f7f7',
   formLabel: 'rgba(0, 0, 0, 0.54)',
   licenseLabel: '#af9f9f',

   tableHeaderBackground: '#006699',
   tableHeaderBackground2: '#9c3',
};

export const STATE_COLORS = {
   Suspended: '#FFFF00',
   'Not Suspended': '#00FF00',
   'Directly Suspended': '#FFFF00',
   'Indirectly Suspended': '#FF6A00',
   'Not Scheduled': '#FF0000',
   Scheduled: '#00FF00',
   Monitoring: '#92D050',
   'External Request': '#246B0E',
   Disabled: '#FF0000',
   'Suspended - Audit Failure': '#FF6AFF',
   'Suspended - DB Restore': '#CC6AFF',
   Queued: '#00FF00',
   Executing: '#00FF00',
};

const CSS_COLOR_NAMES = [
   // 'AliceBlue',
   'AntiqueWhite',
   // 'Aqua',
   // 'Aquamarine',
   // 'Azure',
   // 'Beige',
   // 'Bisque',
   'Black',
   // 'BlanchedAlmond',
   'Blue',
   'BlueViolet',
   'Brown',
   'BurlyWood',
   'CadetBlue',
   'Chartreuse',
   'Chocolate',
   'Coral',
   'CornflowerBlue',
   // 'Cornsilk',
   'Crimson',
   'Cyan',
   'DarkBlue',
   'DarkCyan',
   'DarkGoldenRod',
   'DarkGray',
   'DarkGrey',
   'DarkGreen',
   'DarkKhaki',
   'DarkMagenta',
   'DarkOliveGreen',
   'DarkOrange',
   'DarkOrchid',
   'DarkRed',
   'DarkSalmon',
   'DarkSeaGreen',
   'DarkSlateBlue',
   'DarkSlateGray',
   'DarkSlateGrey',
   'DarkTurquoise',
   'DarkViolet',
   'DeepPink',
   'DeepSkyBlue',
   'DimGray',
   'DimGrey',
   'DodgerBlue',
   'FireBrick',
   'FloralWhite',
   'ForestGreen',
   'Fuchsia',
   'Gainsboro',
   'GhostWhite',
   'Gold',
   'GoldenRod',
   'Gray',
   'Grey',
   'Green',
   'GreenYellow',
   'HoneyDew',
   'HotPink',
   'IndianRed',
   'Indigo',
   'Ivory',
   'Khaki',
   'Lavender',
   'LavenderBlush',
   'LawnGreen',
   'LemonChiffon',
   'LightBlue',
   'LightCoral',
   'LightCyan',
   'LightGoldenRodYellow',
   'LightGray',
   'LightGrey',
   'LightGreen',
   'LightPink',
   'LightSalmon',
   'LightSeaGreen',
   'LightSkyBlue',
   'LightSlateGray',
   'LightSlateGrey',
   'LightSteelBlue',
   'LightYellow',
   'Lime',
   'LimeGreen',
   'Linen',
   'Magenta',
   'Maroon',
   'MediumAquaMarine',
   'MediumBlue',
   'MediumOrchid',
   'MediumPurple',
   'MediumSeaGreen',
   'MediumSlateBlue',
   'MediumSpringGreen',
   'MediumTurquoise',
   'MediumVioletRed',
   'MidnightBlue',
   'MintCream',
   'MistyRose',
   'Moccasin',
   'NavajoWhite',
   'Navy',
   'OldLace',
   'Olive',
   'OliveDrab',
   'Orange',
   'OrangeRed',
   'Orchid',
   'PaleGoldenRod',
   'PaleGreen',
   'PaleTurquoise',
   'PaleVioletRed',
   'PapayaWhip',
   'PeachPuff',
   'Peru',
   'Pink',
   'Plum',
   'PowderBlue',
   'Purple',
   'RebeccaPurple',
   'Red',
   'RosyBrown',
   'RoyalBlue',
   'SaddleBrown',
   'Salmon',
   'SandyBrown',
   'SeaGreen',
   'SeaShell',
   'Sienna',
   'Silver',
   'SkyBlue',
   'SlateBlue',
   'SlateGray',
   'SlateGrey',
   'Snow',
   'SpringGreen',
   'SteelBlue',
   'Tan',
   'Teal',
   'Thistle',
   'Tomato',
   'Turquoise',
   'Violet',
   'Wheat',
   'White',
   'WhiteSmoke',
   'Yellow',
   'YellowGreen',
];

// export const randomColor = () => Math.floor(Math.random() * 16777215).toString(16);
// export const numericColor = (i: number) => Math.floor(decToFrac(i + 3) * 16777215).toString(16);

export const numericColor = (i: number) => CSS_COLOR_NAMES[i % CSS_COLOR_NAMES.length];
